import React from 'react';
import Reflux from 'reflux';
import {Button, message, Popconfirm, Modal, Input, DatePicker, InputNumber, Upload, Icon} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, objectSerial, config, downLoadTemplate, toImportExcel} from 'Utils';
import moment from "moment";
import {
    getGouXiaoUnitList,
    getBatchAcceptList, getDeliveryDetailList2, addSplitQuantity, deleterSplitQuantity
} from "../../service/transportSplit";

const EXCEL_IMPORT_TYPE = 14;

class batchAcceptList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['出库单分批签收'],
            key: 0,
            selectedRowKeys: [],
            gouxiaoUnitList: [],
            rows: [],
            total: 1,
            createTotal: 1,
            createRows: [],
            searchObj: {
                customerId: '',
                salesUnitId: '',
                startCreatedDate: '',
                endCreatedDate: '',
                orderNumber: '',
                deliveryId: '',
                s: 10,
                p: 1
            },
            createSearchObj: {
                customerId: '',
                salesUnitId: '',
                startCreatedDate: '',
                endCreatedDate: '',
                orderNumber: '',
                deliveryId: '',
                s: 10,
                p: 1
            },
            visible: false,
            loading: true,
            createLoading: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.createPageChange = this.createPageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.setCreateFilterParam = this.setCreateFilterParam.bind(this);
        this.createReset = this.createReset.bind(this);
        this.createSubmit = this.createSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportBatchAccept = this.exportBatchAccept.bind(this);
        this.exportUnBatchAccept = this.exportUnBatchAccept.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.openCreate = this.openCreate.bind(this);
        this.downloadTemplate = this.downloadTemplate.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name == 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startCreatedDate: value.from,
                    endCreatedDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}});
        }

    };

    downloadTemplate() {
        downLoadTemplate(EXCEL_IMPORT_TYPE);
    }

    /*筛选重置*/
    advanceReset() {
        this.setState({
            searchObj: {
                customerId: '',
                salesUnitId: '',
                deliveryId: '',
                startCreatedDate: '',
                endCreatedDate: '',
                s: 10,
                p: 1
            }, loading: true
        }, () => {
            this.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    setCreateFilterParam(name, value) {
        if (name == 'shipTime') {
            this.setState({
                createSearchObj: {
                    ...this.state.createSearchObj,
                    startCreatedDate: value.from,
                    endCreatedDate: value.end
                }
            })
        } else {
            this.setState({createSearchObj: {...this.state.createSearchObj, [name]: value}});
        }
    };

    /*筛选重置*/
    createReset() {
        this.setState({
            createSearchObj: {
                customerId: '',
                salesUnitId: '',
                deliveryId: '',
                startCreatedDate: '',
                endCreatedDate: '',
                s: 10,
                p: 1
            }, createLoading: true
        }, () => {
            this.getDeliveryData();
        });
    };

    /* 筛选确认 */
    createSubmit(form) {
        let self = this;
        this.setState({
            createSearchObj: {
                ...this.state.createSearchObj,
                p: 1
            }, createLoading: true
        }, function () {
            self.getDeliveryData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    createPageChange(page, pageSize) {
        let self = this;
        this.setState({
            createSearchObj: {...this.state.createSearchObj, s: pageSize, p: page},
            createLoading: true
        }, function () {
            self.getDeliveryData();
        });
    }

    openCreate() {
        this.setState({visible: true});
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let obj = self.state.searchObj;
        getBatchAcceptList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })

    }

    getDeliveryData() {
        let self = this;
        let obj = self.state.createSearchObj;
        getDeliveryDetailList2(obj).then(result => {
            if (result.status) {
                this.setState({
                    createRows: result.data || [],
                    createTotal: result.total,
                    createLoading: false
                })
            } else {
                message.error(result.message);
                this.setState({createLoading: false});
            }
        })

    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        let self = this;
        this.initData();
        getGouXiaoUnitList({channelCode: 'FX', s: 999}).then(res => { //购货单位
            if (res.status) {
                const data = res.data || [];
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }


    deleteItem(record) {
        deleterSplitQuantity({id: record.id}).then(res => {
            if (res.code === 200) {
                openNotice('success', '删除成功');
                this.initData();
            }
        });
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    exportBatchAccept() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tgTransTransportSplitHeader/exportBatchAccept?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    exportUnBatchAccept() {
        let _searchObj = {...this.state.createSearchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tgTransTransportSplitHeader/exportUnBatchAccept?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    add = (record) => {
        if (record.splitQuantity == null || record.signDate == null) {
            openNotice('error', '请填写签收数量和日期');
            return;
        } else {
            addSplitQuantity(record).then(res => {
                if (res.code === 200) {
                    openNotice('success', '添加成功');
                    this.getDeliveryData();
                }
            });
        }
    }

    createRowChange = (index, colume, value) => {
        var newData = [...this.state.createRows];
        if (colume == 'signDate' || colume == 'splitQuantity') {
            newData[index][colume] = value;
        } else {
            newData[index][colume] = value.target.value;
        }
        this.setState({createRows: newData});
    }


    render() {
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            gouxiaoUnitList,
            loading,
            visible,
            createRows,
            createTotal,
            createSearchObj,
            createLoading
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '签收日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startCreatedDate,
                        end: searchObj.endCreatedDate
                    }
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    multiple: false,
                    showSearch: true,
                    options: gouxiaoUnitList,
                    defaultValue: searchObj.salesUnitId
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                }, {
                    name: 'remark',
                    label: '备注',
                    text: '输入备注',
                    type: 'default',
                    defaultValue: searchObj.remark
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };

        const createProps = {
            fileds: [
                {
                    name: 'shipTime',
                    label: '发运日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: createSearchObj.startCreatedDate,
                        end: createSearchObj.endCreatedDate
                    }
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    multiple: false,
                    showSearch: true,
                    options: gouxiaoUnitList,
                    defaultValue: createSearchObj.salesUnitId
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: createSearchObj.orderNumber
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: createSearchObj.deliveryId
                }
            ],
            handle: this.createSubmit,
            reset: this.createReset,
            fieldHandle: this.setCreateFilterParam
        };

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '发运明细ID',
                    dataIndex: 'deliveryDetailId'
                },
                {
                    title: '客户名称',
                    dataIndex: 'custName'
                },
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                },
                {
                    title: '发运日期',
                    dataIndex: 'confirmDate',
                    render: (text, record, index) => {
                        return <div>{moment(parseInt(text)).format('YYYY-MM-DD')}</div>
                    }
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '出库数量',
                    dataIndex: 'quantity'
                },
                {
                    title: '签收数量',
                    dataIndex: 'splitQuantity'
                },
                {
                    title: '签收日期',
                    dataIndex: 'signDate',
                    render: (text, record, index) => {
                        return <div>{moment(parseInt(text)).format('YYYY-MM-DD')}</div>
                    }
                },
                {
                    title: '创建日期',
                    dataIndex: 'createdDate',
                    render: (text, record, index) => {
                        return <div>{moment(parseInt(text)).format('YYYY-MM-DD HH:mm:ss')}</div>
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '操作',
                    render: (text, record, index) =>
                        <div>
                            <div className="event">
                                <Popconfirm placement="left" title='您确定要删除吗！' onConfirm={() => {
                                    this.deleteItem(record)
                                }}>
                                    <Button size={'small'} type="danger">删除</Button>
                                </Popconfirm>
                            </div>
                        </div>
                }
            ],
            rows
        };

        const createViewProps = {
            loading: createLoading,//更新表格数据中
            rowKey: 'deliveryDetailId',
            pageParam: {
                total: createTotal,
                current: createSearchObj.p,//当前页码
                pageSize: createSearchObj.s,//当前分页数
                onChange: this.createPageChange
            },
            columns: [
                {
                    title: '发运明细ID',
                    dataIndex: 'deliveryDetailId'
                },
                {
                    title: '客户名称',
                    dataIndex: 'custName'
                },
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                },
                {
                    title: '发运日期',
                    dataIndex: 'confirmDate',
                    render: (text, record, index) => {
                        return <div>{moment(parseInt(text)).format('YYYY-MM-DD')}</div>
                    }
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '出库数量',
                    dataIndex: 'quantity'
                },
                {
                    title: '剩余数量',
                    dataIndex: 'unSplitQuantity'
                },
                {
                    title: '签收数量',
                    dataIndex: 'splitQuantity',
                    render: (text, record, index) => {
                        return <InputNumber min={0} value={text} max={record.unSplitQuantity}
                                            onChange={this.createRowChange.bind(this, index, 'splitQuantity')}/>
                    }
                },
                {
                    title: '签收日期',
                    dataIndex: 'signDate',
                    render: (text, record, index) => {
                        return <DatePicker format="YYYY-MM-DD" value={text ? text : null}
                                           onChange={this.createRowChange.bind(this, index, 'signDate')}/>
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    render: (text, record, index) => {
                        return <Input value={text}
                                      onChange={this.createRowChange.bind(this, index, 'remark')}/>
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'active',
                    render: (text, record, index) =>
                        <div>
                            <Button type="primary"
                                    onClick={this.add.bind(this, record)}>添加</Button>
                        </div>
                }
            ],
            rows: createRows
        };

        const uploadParam = toImportExcel(EXCEL_IMPORT_TYPE, () => {
            this.initData();
        });

        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, left: 0}}
                            onClick={this.openCreate}>录入签收</Button>
                    {/*<Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"*/}
                    {/*        onClick={this.exportChange}>导出</Button>*/}
                    <Button style={{position: 'absolute', bottom: 8, right: 200}}
                            onClick={this.downloadTemplate}>下载模板</Button>
                    <Upload {...uploadParam}>
                        <Button style={{position: 'absolute', bottom: 8, right: 100}}>
                            <Icon type="upload"/>导入
                        </Button>
                    </Upload>
                    <Button style={{position: 'absolute', bottom: 8, right: 2}} icon="export"
                            onClick={this.exportBatchAccept}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>
            <Modal visible={visible}
                   title='录入签收'
                   onOk={this.handleOk}
                   onCancel={this.handleCancel}
                   maskClosable={false}
                   width='100%'
                   style={{top: 20}}
                   footer={null}>
                <div className="advanceForm-box">
                    <div className="advanceForm-content">
                        <AdvanceFormNew {...createProps} />
                    </div>
                    <div className="dms-table-box">
                        <div className="dms-table-head">
                            <Button style={{position: 'absolute', bottom: 8, right: 2}} icon="export"
                                    onClick={this.exportUnBatchAccept}>导出</Button>
                        </div>
                        <TableView {...createViewProps} />
                    </div>
                </div>
            </Modal>
        </div>

    }
}

export default withRouter(batchAcceptList);



// WEBPACK FOOTER //
// ./src/routes/transportSplit/batchAcceptList.js